module.exports = __webpack_public_path__ + "img/logo3.b4e83e03.png";